(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("FastTrack.Initiate",
            {
                url: "/Initiate",
                component: "fasttrackinitate",
                requiredPermissions: [{ AccessObject: "Transaction", ActionType: "Create" }],
                resolve: {
                    agent: ["agentApi", function (agentApi) {
                        return agentApi.getCurrentAgent();
                    }],
                    states: [
                        "states", function (states) {
                            return states;
                        }
                    ],
                    prefillCategories: ["prefillCategories", function (prefillCategories) {
                        return prefillCategories;
                    }],
                    genders: [
                        "genders", function (genders) {
                            return genders;
                        }
                    ],
                    transactions: ["transactionApi", function (transactionApi) {
                        return transactionApi.getTransactionsForUser();
                    }],
                    transactionStatus: ["transactionStatus", function (transactionStatus) {
                        return transactionStatus;
                    }],
                    transactionStagesToUiRouter: ["transactionStagesToUiRouter", function (transactionStagesToUiRouter) {
                        return transactionStagesToUiRouter;
                    }]
                }
            });
    }]);

    app.component("fasttrackinitate",
        {
            templateUrl: "/App/FastTrack/Initiate/template.html",
            controller: fastTrackInitateController,
            bindings: {
                agent: "<",
                transactionGroup: "<",
                states: "<",
                prefillCategories: "<",
                genders: "<",
                transactions: "<",
                transactionStatus: "<",
                transactionStagesToUiRouter: "<"
            }
        });

    fastTrackInitateController.$inject = [
        "$state", "$scope", "clientApi", "transactionApi", "$q", "$mdDialog", "$timeout", "agentApi", "_",
        "transactionRelationshipApi", "questionApi", "transactionQuestionApi", "transactionProductApi",
        "transactionGroupProductApi", "productApi", "firelightSsoApi", "transactionPrefillApi", "transactionDocumentApi",
        "externalLoading2", "moment", "personApi", "$window", "portalApi"
    ];

    function fastTrackInitateController($state, $scope, clientApi, transactionApi, $q, $mdDialog, $timeout, agentApi, _, transactionRelationshipApi, questionApi, transactionQuestionApi, transactionProductApi, transactionGroupProductApi, productApi, firelightSsoApi, transactionPrefillApi, transactionDocumentApi, externalLoading2, moment, personApi, $window, portalApi) {
        var $ctrl = this;

        $ctrl.primaryAgent = $ctrl.agent;
        if ($ctrl.primaryAgent)
            $ctrl.primaryAgent.Term = $ctrl.primaryAgent.Person.FirstName + " " + $ctrl.primaryAgent.Person.LastName;
        $ctrl.secondaryAgents = [];

        var errorAlert = $mdDialog.alert({
            title: "An error saving has occured.  Please try again.",
            ariaLabel: "Error alert",
            ok: "Ok",
            skipHide: true
        });

        ng.extend($ctrl,
            {
                ui: { saving: false, launchFirelightApp: false, launchPaperApp: false, pageIndex: 0 },
                client: { Person: {} },
                transaction: {
                    Agents: []
                },
                setProducts: setProducts,
                submitToFirelight: submitToFirelight,
                initiateManualApp: initiateManualApp,
                selectProduct: selectProduct,
                createTransaction: createTransaction,
                openFirelightDialog: openFirelightDialog,
                currentStatus: currentStatus,
                goToLast: goToLast,
                loadFiles: loadFiles,
                downloadAll: downloadAll,
                download: download,
                startFirelightSso: startFirelightSso,
                iPipelineSso: iPipelineSso
            });

        this.$onInit = function () {
            // TODO: dynamically fill this array (based on transaction status/stage)
            this.filterOptions = [];

            this.sortOptions = [
                { Label: "Oldest First", Value: "LastUpdatedOn" },
                { Label: "Newest First", Value: "-LastUpdatedOn" }
            ];

            $ctrl.ui.sortTransactions = $ctrl.sortOptions[1];

            setProducts();

            getStage();
        };


        function setProducts() {
            return transactionGroupProductApi.getPublishedProducts($ctrl.transactionGroup.Id).then(function (products) {

                $ctrl.products = products;

                $ctrl.carrierList = [];
                $ctrl.lobcList = [];
                ng.forEach(products, function (p) {
                    p.Name = p.Product.Name;
                    p.CarrierId = p.Product.Carrier.Id;
                    p.CarrierName = p.Product.Carrier.Business.Name;
                    p.LineOfBusinessCategoryId = p.Product.LineOfBusinessCategory.Id;
                    p.LineOfBusinessCategoryName = p.Product.LineOfBusinessCategory.Name;



                    var carrierIndex = _.findIndex($ctrl.carrierList, function (row) { return row.Id === p.CarrierId; });
                    if (carrierIndex === -1)
                        $ctrl.carrierList.push({ Id: p.CarrierId, Name: p.CarrierName });

                    var lobcIndex = _.findIndex($ctrl.lobcList, function (row) { return row.Id === p.LineOfBusinessCategoryId; });
                    if (lobcIndex === -1)
                        $ctrl.lobcList.push({ Id: p.LineOfBusinessCategoryId, Name: p.LineOfBusinessCategoryName });

                    //Use this to test if the product's state filter works. Will delete before PR
                    //var randomState = $ctrl.states[Math.floor(Math.random() * $ctrl.states.length)];
                    //if (p.Product.StateCodes && p.Product.StateCodes.length === 0)
                    //    p.Product.StateCodes.push(randomState.ShortName);
                });

            });
        }

        $ctrl.filterProducts = function (product) {
            //encountered at least one product with a null value for StateCodes for some reason
            if (product.Product.StateCodes !== null) {
                if (product.Product.StateCodes.length > 0)
                    return product.Product.StateCodes.indexOf($ctrl.transaction.Jurisdiction) > -1 && product.CarrierId === $ctrl.transaction.CarrierId;
            }
            return product.CarrierId === $ctrl.transaction.CarrierId;
        };

        function selectProduct(productId) {
            $ctrl.selectedProduct = _.find($ctrl.products, function (p) { return p.ProductId === productId });
        }

        function findWithAttr(array, attr, value) {
            for (var i = 0; i < array.length; i += 1) {
                if (array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        }

        function openFirelightDialog($event) {

            $mdDialog.show({
                bindToController: true,
                controllerAs: "$ctrl",
                controller: dialogCtrl,
                templateUrl: "/App/FastTrack/FireLightDialog/template.html",
                parent: ng.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    genders: $ctrl.genders
                }
            }).then(function (flPrefills) {

                if (flPrefills.Email)
                    $ctrl.client.EmailAddress = flPrefills.Email;
                if (flPrefills.Phone)
                    $ctrl.client.Phone = flPrefills.Phone;
                if (flPrefills.Dob)
                    $ctrl.client.Person.Dob = flPrefills.Dob;

                //if (flPrefills.Email)
                //{
                //    $ctrl.submitToFirelight();
                //}

                $ctrl.submitToFirelight();

            });


        }

        function initiateManualApp() {
            $ctrl.ui.saving = true;
            $ctrl.ui.launchPaperApp = true;
            if ($ctrl.transaction.Id === null) {

                var promise = Promise.resolve(createTransaction());
                promise.then(function (transactionId) {
                    $state.go("FastTrack.PaperApplication", { transactionId: transactionId }, { reload: true });

                });
            } else {
                $state.go("FastTrack.PaperApplication", { transactionId: $ctrl.transaction.Id }, { reload: true });
            }
        }

        function createTransaction() {
            document.activeElement.blur();

            return clientApi.add($ctrl.client).then(function (dbClient) {

                $ctrl.transaction.ClientId = dbClient.Id;
                $ctrl.transaction.PrimaryAgentId = $ctrl.primaryAgent.Id;
                $ctrl.transaction.IsFastTrack = true;

                var date = (new Date().getMonth() + 1) + "/" + new Date().getDate() + "/" + new Date().getFullYear();

                // $ctrl.transaction.Name = $ctrl.client.Person.FirstName + " " + $ctrl.client.Person.LastName + " (" + date + ")";

                return transactionApi.add($ctrl.transaction).then(function (dbTransaction) {

                    var trxPromises = [];
                    trxPromises.push(transactionApi.updateJurisdiction(dbTransaction.Id, dbTransaction));

                    var relationship = {
                        TransactionId: dbTransaction.Id,
                        RelatedClientId: $ctrl.transaction.ClientId,
                        Type: "Client"
                    };

                    trxPromises.push(transactionRelationshipApi.add(dbTransaction.Id, relationship)
                        .then(function (rel) {

                            return transactionRelationshipApi.get(dbTransaction, rel.Id).then(function (relationship) {


                                //console.log(relationship)
                                if ($ctrl.selectedProduct.Product.FirelightProductCode !== null) {

                                    if ($ctrl.client.EmailAddress)
                                        relationship.EmailAddress = { Value: $ctrl.client.EmailAddress }

                                    if ($ctrl.client.Phone)
                                        relationship.PhoneNumber = { Value: $ctrl.client.Phone.replace(/\D/g, "") }

                                    if ($ctrl.client.Person.Dob) {
                                        relationship.Person.Dob = new Date($ctrl.client.Person.Dob);
                                        var dob = moment(relationship.Person.Dob);
                                        relationship.Person.Age = moment().diff(dob, "years");
                                    }

                                    personApi.update(relationship.Person).then(function () {

                                        transactionRelationshipApi.update($ctrl.transaction.Id, rel.Id, relationship).then(
                                            function () {
                                                /* not using ssn for now */
                                                //if ($ctrl.client.Person.Ssn) {
                                                //    relationship.Person.Ssn = $ctrl.client.Person.Ssn.replace(/[^0-9]/g, "");
                                                //    personApi.updateSsn(relationship.Person.Id,
                                                //        { Ssn: relationship.Person.Ssn });
                                                //}
                                            });
                                    });
                                }

                                var relationships = [];
                                relationships.push(relationship);

                                ng.forEach($ctrl.prefillCategories,
                                    function (cat) {
                                        cat.relationships = ng.copy(relationships);

                                        if (cat.Label === "Owner") {

                                            cat.relationships[findWithAttr(cat.relationships, "Type", "Client")]
                                                .IsActive = true;

                                            ng.forEach(cat.relationships,
                                                function (r) {
                                                    //if Type is not Client remove from Owner Category
                                                    if (r.Type !== "Client") {
                                                        cat.relationships.splice(cat.relationships.indexOf(r),
                                                            1);
                                                    }
                                                });

                                        } else {
                                            ng.forEach(cat.relationships,
                                                function (r) {
                                                    //if Type is Client and Label is NOT Annuitant remove from Other Categories
                                                    if (r.Type === "Client" && cat.Label !== "Annuitant") {
                                                        cat.relationships.splice(cat.relationships.indexOf(r), 1);
                                                    }
                                                });
                                        }
                                    });

                                var prefillPromises = [];
                                ng.forEach($ctrl.prefillCategories,
                                    function (cat) {
                                        ng.forEach(cat.relationships,
                                            function (r) {
                                                if (r.IsActive) {
                                                    var model =
                                                    {
                                                        transactionId: r.TransactionId,
                                                        relationshipId: r.Id,
                                                        relatedClientId: r.RelatedClientId,
                                                        categoryType: cat.Value,
                                                        isActive: r.IsActive
                                                    }

                                                    prefillPromises.push(transactionPrefillApi
                                                        .createNewTransactionPrefill(model));
                                                }
                                            });
                                    });
                            });
                        }));

                    var transactionProductPromises = [];
                    ng.forEach($ctrl.products, function (product) {
                        transactionProductPromises.push(transactionProductApi.createTransactionProduct(
                            {
                                ProductId: product.ProductId,
                                TransactionId: dbTransaction.Id,
                                Name: product.Product.Name,
                                Cusip: product.Product.Cusip,
                                FireLightProductcode: product.Product.FireLightProductCode,
                                RightBridgeProductCode: product.Product.RightBridgeProductCode,
                                RetireUpProductCode: product.Product.RetireUpProductCode,
                                LineOfBusinessCategoryId: product.Product.LineOfBusinessCategory.Id,
                                CarrierId: product.Product.Carrier.Id,
                                CarrierName: product.Product.Carrier.Business.Name,
                                LineOfBusinessCategoryName: product.Product.LineOfBusinessCategory.Name,
                                ExcludeFromReviewQueue: product.ExcludeFromReviewQueue
                            }));
                    });

                    trxPromises.push($q.all(transactionProductPromises)
                        .then(function () {
                            return transactionProductApi.getTransactionProducts(dbTransaction.Id).then(function (transactionProducts) {

                                $ctrl.transaction.TransactionProduct = _.find(transactionProducts, function (p) { return p.ProductId === $ctrl.transaction.ProductId; });

                                return transactionApi.updateTransactionProduct(dbTransaction.Id,
                                    {
                                        Id: dbTransaction.Id,
                                        TransactionProductId: $ctrl.transaction.TransactionProduct.Id
                                    }).then(function (product) {
                                        $ctrl.transaction.Product = product;
                                    });
                            });
                        })
                    );

                    return $q.all(trxPromises).then(function () {

                        return dbTransaction.Id;
                    });
                },
                    function (error) {
                        $ctrl.ui.saving = false;
                        $ctrl.launchPaperApp = false;
                        $ctrl.ui.launchFirelightApp = false;
                        $mdDialog.show(errorAlert);
                    });
            });
        }

        function submitToFirelight() {

            $ctrl.ui.saving = true;
            $ctrl.ui.launchFirelightApp = true;
            var promise = Promise.resolve(createTransaction());
            promise.then(function (transactionId) {
                $ctrl.transaction.Id = transactionId;
                $ctrl.transaction.TransactionStatus = "SubmittedToFirelight";
                transactionApi.updateTransactionStatus($ctrl.transaction.Id, $ctrl.transaction).then(function () {
                    var w = window.open();
                    w.document.write(externalLoading2.html);
                    firelightSsoApi.InitiateFirelightSso(transactionId).then(
                        function (data) {
                            w.document.write(data);
                            w.document.forms.samlform.submit();
                        },
                        function (error) {
                            $ctrl.ui.saving = false;
                            $ctrl.ui.launchFirelightApp = false;
                            w.document.write(
                                " Failed.  There was an error accessing this resource.");
                        });
                }).then(function () {
                    $state.go("FastTrack.Initiate", { transactionId: transactionId }, { reload: true });
                });

            });
        }

        function iPipelineSso() {
            var w = window.open();
            w.document.write(externalLoading2.html);
            portalApi.launchiPipelineSso().then(function (data) {

                //console.log(data);
                w.document.write(data);
                w.document.forms.samlform.submit();

            }, function () {
                w.document.write(" Failed.  There was an error accessing this resource.");
            });
        }

        function goToLast(transaction) {

            if (transaction.IsFastTrack && transaction.LastTransactionStage === "PaperApplication") {
                $state.go("FastTrack.PaperApplication", { transactionId: transaction.Id }, { reload: true });
            } else {
                var uiRouterState = _($ctrl.transactionStagesToUiRouter)
                    .filter(function (stage) { return stage.TransactionStage === transaction.LastTransactionStage }).map("UiRouterRoute")
                    .value()[0];

                $state.go(uiRouterState, { transactionId: transaction.Id });
            }

        }

        function currentStatus(status) {
            var isLocked = _.findIndex($ctrl.transactionStatus.locked, function (item) {
                return item.Value === status;
            });

            if (isLocked !== -1) {
                return true;
            } else {
                return false;
            }
        }

        function getStage() {
            ng.forEach($ctrl.transactions,
                function (t) {
                    if (t.TransactionStatus !== "PaperApplication") {
                        t.stageText = "Currently At:";
                    } else {
                        t.stageText = "Awaiting:";
                    }

                    if (t.TransactionStatus === "SubmittedToFirelight" && t.CurrentWorkflowQueue === null)
                        t.stageText = "";

                    if (t.CurrentWorkflowQueue) {
                        t.statusText = t.CurrentWorkflowQueue;
                    } else {
                        if (t.TransactionStatus === "PaperApplication") {
                            t.statusText = "Paper Application";
                        }
                    }

                    if (t.TransactionReviewStatus !== null) {
                        if (t.TransactionReviewStatus)
                            t.statusText = "Approved";
                        else
                            t.statusText = "Declined";
                        t.stageText = "Application was: ";
                    }
                });
        }

        function loadFiles(transaction) {
            //console.log(transaction)
            if (!!transaction.showFiles) {
                transaction.loadingFiles = true;

                var promises = [];
                transaction.transactionDocuments = [];
                promises.push(transactionDocumentApi.getTransactionDocuments(transaction.Id).then(function (docs) {
                    if (docs.length > 0) {
                        transaction.transactionDocuments = docs;
                    }
                }));

                promises.push(transactionApi.getSummaryExists(transaction.Id).then(function (summary) {
                    if (summary !== null && summary === true) {
                        transaction.transactionDocuments.push({
                            RequiredFileName: "Summary",
                            Id: "summary"
                        });
                    }
                }));

                /*promises.push(transactionApi.getTransactionRightBridgeResponseWithDocuments(transaction.Id).then(function (rightBridgeResponse) {
                    if (rightBridgeResponse !== null && rightBridgeResponse.Documents.length > 0) {
                        transaction.transactionDocuments.push({
                            RequiredFileName: "RightBRIDGE",
                            Id: "rightbridge"
                        });   
                    }                      
                }));*/

                promises.push(transactionApi.getTransactionRetireUpResponse(transaction.Id).then(function (retireUpResponse) {
                    if (retireUpResponse !== null && retireUpResponse.Documents.length > 0) {
                        transaction.transactionDocuments.push({
                            RequiredFileName: "RetireUp Pro",
                            Id: "retireup"
                        });
                    }
                }));

                $q.all(promises).then(function () {
                    return transaction.loadingFiles = false;
                }, function () {
                    return transaction.loadingFiles = false;
                });

            }

            return transaction.loadingFiles = false;
        };

        function download(transaction, file) {

            if (file.Id === "summary") {
                $window.open(transactionApi.getSummaryUrl(transaction.Id));
            }
            /*else if (file.Id === "rightbridge") {
                transactionApi.getTransactionRightBridgeResponseWithDocuments(transaction.Id).then(function (rightBridgeResponse) {
                    ng.forEach(rightBridgeResponse.Documents, function (x) {
                        (function (doc) {
                            $window.open(transactionApi.getRightBridgeTransactionDocumentUrl(transaction.Id, rightBridgeResponse.Id, doc.FileName));
                        })(x);
                    });
                });
            }*/

            else if (file.Id === "retireup") {
                transactionApi.getTransactionRetireUpResponse(transaction.Id).then(function (retireUpResponse) {
                    ng.forEach(retireUpResponse.Documents, function (x) {
                        (function (doc) {
                            $window.open(transactionApi.getRetireUpTransactionDocumentUrl(transaction.Id, retireUpResponse.Id, doc.FileName));
                        })(x);
                    });
                });
            }

            else if (file.Id) {
                $window.open(transactionDocumentApi.getUrl(transaction.Id, file.Id));
            }
        }

        function downloadAll(transaction) {

            ng.forEach(transaction.transactionDocuments, function (file) {
                download(transaction, file);
            });
        }

        function startFirelightSso($event, transaction) {
            var w = window.open();
            w.document.write(externalLoading2.html);
            firelightSsoApi.InitiateFirelightSso(transaction.Id).then(function (data) {
                w.document.write(data);
                w.document.forms.samlform.submit();
            }, function () {
                w.document.write(" Failed.  There was an error accessing this resource.");
            });
        }

    }

    dialogCtrl.$inject = ["$mdDialog", "$window", "$timeout"];
    function dialogCtrl($mdDialog, $window, $timeout) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                cancelDialog: cancelDialog,
                continueToFirelight: continueToFirelight
            });
        
        this.$onInit = function () {
            $ctrl.flPrefills = [];
        }

        function cancelDialog() {
            $mdDialog.cancel();
        }

        function continueToFirelight() {
            $mdDialog.hide($ctrl.flPrefills);
        }
    }
})(window.app, window.angular);